import {
  WHATSAPP_STATUS_PENDING_COLOR,
  WHATSAPP_STATUS_SENT_COLOR,
  WHATSAPP_STATUS_DELIVERED_COLOR,
  WHATSAPP_STATUS_READ_COLOR,
  WHATSAPP_STATUS_FAILED_COLOR
} from '../constants/whatsapp'

export type MessageStatus = 'pending' | 'sent' | 'delivered' | 'read' | 'failed'

export interface MessageWithStatus {
  id: string
  direction: 'inbound' | 'outbound'
  is_sent?: boolean
  is_delivered?: boolean
  is_read?: boolean
  is_failed?: boolean
}

export function getSafeMessageStatus(message: MessageWithStatus): MessageStatus {
  // Priority: failed > read > delivered > sent > pending
  if (message.is_failed) return 'failed'
  
  // Handle inconsistent states gracefully
  if (message.is_read) {
    // If read, ensure delivered is also true (fix inconsistency)
    return 'read'
  }
  
  if (message.is_delivered) return 'delivered'
  if (message.is_sent) return 'sent'
  
  return 'pending'
}

export function getStatusColor(status: MessageStatus): string {
  const colors = {
    pending: WHATSAPP_STATUS_PENDING_COLOR,
    sent: WHATSAPP_STATUS_SENT_COLOR,
    delivered: WHATSAPP_STATUS_DELIVERED_COLOR,
    read: WHATSAPP_STATUS_READ_COLOR,
    failed: WHATSAPP_STATUS_FAILED_COLOR
  }
  return colors[status]
}
